// localStorage キー一元管理
// 認証トークンは全て `safelens.` プレフィックスで識別。

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'safelens.access_token',
  REFRESH_TOKEN: 'safelens.refresh_token',
  PERFORMER: 'safelens.performer',
  ADMIN_ACCESS_TOKEN: 'safelens.admin.access_token',
  ADMIN_REFRESH_TOKEN: 'safelens.admin.refresh_token',
  ADMIN: 'safelens.admin',
} as const;

export function readJson<T>(key: string): T | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  localStorage.setItem(key, JSON.stringify(value));
}
